export const policyTransforms = {
  policyLimitSelection: {
    1: [
      {
        target: "policyLimitAmount",
        changes: {
          label: "Policy Individual:",
          name: "individualPolicyLimit",
          hidden: false,
          required: true,
        },
      },
    ],
    2: [
      {
        target: "policyLimitAmount",
        changes: {
          label: "Policy Incident:",
          name: "incidentPolicyLimit",
          hidden: false,
          required: true,
        },
      },
    ],
    3: [
      {
        target: "policyLimitAmount",
        changes: {
          label: "Policy Limit Umbrella:",
          name: "umbrellaPolicyLimit",
          hidden: false,
          required: true,
        },
      },
    ],
    null: [
      {
        target: "policyLimitAmount",
        changes: {
          hidden: true,
          required: false,
        },
      },
    ],
  },
  uninsuredMotoristSelection: {
    1: [
      {
        target: "uninsuredMotorist",
        changes: {
          name: "uninsuredMotoristIndividual",
          label: "UM Individual:",
          required: true,
          hidden: false,
        },
      },
    ],
    2: [
      {
        target: "uninsuredMotorist",
        changes: {
          name: "uninsuredMotoristIncident",
          label: "UM Incident:",
          required: true,
          hidden: false,
        },
      },
    ],
    3: [
      {
        target: "uninsuredMotorist",
        changes: {
          name: "uninsuredMotoristIndividual",
          label: "UM Individual:",
          required: true,
          hidden: false,
        },
      },
    ],
    4: [
      {
        target: "uninsuredMotorist",
        changes: {
          name: "uninsuredMotoristIncident",
          label: "UM Incident:",
          required: true,
          hidden: false,
        },
      },
    ],
    5: [
      {
        target: "uninsuredMotorist",
        changes: {
          name: "uninsuredMotorist",
          label: "Do Not Use",
          required: false,
          hidden: true,
        },
      },
    ],
    null: [
      {
        target: "uninsuredMotorist",
        changes: {
          hidden: true,
          required: false,
        },
      },
    ],
  },
};
